/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import _, { isUndefined } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import PolicyService from '../../../../capabilities/gw-capability-gateway/services/PolicyService';
import UserService from '../../../../capabilities/gw-capability-gateway/services/UserService';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { LobIconUtil, DateUtil } from '@xengage/gw-portals-util-js';
import { PolicyClaims } from 'gw-capability-gateway-claim-react';
import { AccountService } from 'gw-capability-gateway-policy';
import { PolicyCommission } from 'gw-capability-gateway-commission-react';
import { isCapabilityEnabled } from '@xengage/gw-portals-config-js';
import { withRouter } from 'react-router-dom';
import { Loader, Tooltip, withModalContext } from '@jutro/components';
import GatewayDocumentService from '../../../../capabilities/gw-capability-gateway-document/services/GatewayDocumentService';
import { DocumentsPage } from 'gw-capability-document-react';
import { DependencyProvider } from '@xengage/gw-portals-dependency-react';
import { CommonRoutes } from 'gw-capability-gateway-react';
import { MLPolicyChangeBtnComponent } from 'ml-capability-policychange-common-react';
import { MLNewQuoteDialogModal, MLNewQuoteDialogModalMessages } from 'gw-capability-gateway-quoteandbind-common-react';
import { FormModalPopover } from 'ml-components-platform-react';
import { MLLocalDateUtil } from 'ml-portals-util-js';
import { MLTagManagerService, withMLModalService, AskServiceOpsService } from 'ml-portals-services-react'
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import cx from 'classnames';
import { ViewModelForm, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import metadata from './MLPolicyDetails.metadata.json5';
import styles from './MLPolicyDetails.module.scss';
import messages from './MLPolicyDetails.messages';
import pageRouting from './Policies-config.json5';
import MLTileComponent from '../../components/MLTileComponent/MLTileComponent';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';

import { Button } from '@jutro/legacy/components';
import { MLStateRolloutService } from "ml-services-common-react";

import { Identify } from "../../components/TrackEvent/TrackEvent";

import { TranslatorContext, withIntl } from '@jutro/legacy/locale';

const { capabilitiesConfig } = appConfig;
const askSoService = AskServiceOpsService();

const DocumentPageService = {
    getDocuments: PolicyService.getDocumentsForPolicy,
    generateUploadToken: GatewayDocumentService.generateUploadToken,
    uploadDocument: GatewayDocumentService.uploadDocument,
    removeDocument: GatewayDocumentService.removeDocument,
    // downloadDocument: GatewayDocumentService.downloadDocument
};

function documentFeatureTurnedOn(routes) {
    const documentRoute = {
        path: '/documents',
        component: DocumentsPage
    };
    if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'document' })) {
        routes.push(documentRoute);
    }
}

const MLPolicyDetailsWithNotificationWithoutModalContext = (props) => {
  const notificationUtil = MLNotificationBlockUtil();

  return (
    <MLPolicyDetailsWithoutModalContext
      {...props}
      notificationUtil={notificationUtil}
    />
  );
};

class MLPolicyDetailsWithoutModalContext extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        match: PropTypes.shape({
            path: PropTypes.string,
            params: PropTypes.shape({
                policyNumber: PropTypes.string
            }),
            url: PropTypes.string
        }).isRequired,
        authHeader: PropTypes.shape({}).isRequired,
        authenticated: PropTypes.bool.isRequired,
        intl: PropTypes.func.isRequired,
        location: PropTypes.shape({
            state: PropTypes.string,
            pathname: PropTypes.string
        }).isRequired,
        viewModelService: PropTypes.shape({
            create: PropTypes.func.isRequired,
            clone: PropTypes.func.isRequired,
        }).isRequired,
        history: PropTypes.shape({
            location: PropTypes.shape({
                state: PropTypes.shape({})
            })
        }).isRequired
    };

    static contextType = TranslatorContext;

    state = {
        policyResponse: {},
        policyBillingData: {},
        currentView: undefined,
        isLoading: true,
        commissionTurnedOn: false,
        canAccessGroup: undefined,
        showProgressDialog: false,
        currentPolicy: undefined,
        policySelectedChanged: false,
        showContingenciesErrorIcon: false
    };

    componentDidMount() {
        this.getPolicyDetails();

    }

    componentDidUpdate(preProp, preState) {
        const {
            location: { pathname },
            intl
        } = this.props;

        const {
            addErrorAlert,
            clearBlockAlerts,
            getNumberOfAlerts
        } = this.props.notificationUtil;

        const splittedPathname = pathname.split('/');
        const currentPage = _.last(splittedPathname);
        const currentPolicy = splittedPathname[2];

        if (preState.currentView !== currentPage) {
            this.updateCurrentView(currentPage);
        }

        if (preState.currentPolicy !== currentPolicy) {
            this.updateCurrentPolicy(currentPolicy);
            if (preState.currentPolicy) {
                this.getPolicyDetails();
                this.updatePolicySelectedChanged(true);
                this.updateProgressDialog(false); // call modalservice.hideProgressDialog in MLSummary.jsx after data loaded for latest selected policy
            }
        } else if (preState.isLoading && !this.state.isLoading) {
            this.hideProgressDialog();
            this.updatePolicySelectedChanged(false);
        }

        if (!this.state.showProgressDialog && (this.state.isLoading || this.state.policySelectedChanged)) {
            this.showProgressDialog();
        }

       if (preState.policyResponse !== this.state.policyResponse) {
            const BLOCK_NAME = 'futureCancellationBanner';
            const { latestPeriod } = this.state.policyResponse || {};
            const { addErrorAlert, clearBlockAlerts } = this.props.notificationUtil;

            clearBlockAlerts(BLOCK_NAME);

            if (latestPeriod?.scheduleCancellationDate_Ext) {
                addErrorAlert(
                    this.props.intl.formatMessage(messages.futureCancellationBanner, {
                        date: moment(latestPeriod.scheduleCancellationDate_Ext).format('MM/DD/YYYY')
                    }),
                    BLOCK_NAME
                );
            }
        }
    }

    showProgressDialog = () => {
        this.setState({ showProgressDialog: true })
        this.props.modalService.showProgressDialog("Loading...");
    }

    hideProgressDialog = () => {
        this.setState({ showProgressDialog: false })
        this.props.modalService.hideProgressDialog();
    }

    updateProgressDialog = (flag) => {
        this.setState({ showProgressDialog: flag })
    }

    callIdentifyAPI(currentPage, policyDetails) {
        const {
            authHeader,
            authenticated
        } = this.props;

        if (authenticated && policyDetails.latestPeriod) {
            try {
                const props = {
                    pol_state: policyDetails.latestPeriod?.baseState,
                    lob: policyDetails.product?.productCode,
                    isCompRater: undefined,
                    quoteID: undefined,
                    bundleIndicator: undefined,
                    step: currentPage,
                    PolicyNumber: policyDetails.policyNumber
                }

                Identify('Policy Screen Reached', props, null, authHeader)
            } catch (e) {
                console.error(`Error calling identify API in MLPolicyDetails: ${e.message}`);
            }
        }
    };

    updateCurrentView(currentPage) {
        if (currentPage !== this.state.currentView) {
            this.callIdentifyAPI(currentPage, this.state.policyResponse);
        }

        this.setState({
            currentView: currentPage
        });
    }

    updateCurrentPolicy(currentPolicy) {
        this.setState({
            currentPolicy: currentPolicy
        });
    }

    updatePolicySelectedChanged(policySelectedChanged) {
        this.setState({
            policySelectedChanged: policySelectedChanged
        })
    }

    getAccountHolderNameandNumber = (accountData, type) => {
        if (_.isEmpty(accountData)) {
            return null;
        }
        if (type === 'status') {
            return accountData.latestPeriod.displayStatus;
        }
        return `${accountData.product.productName} (${accountData.policyNumber})`;
    };

    getRoutesWithFeature() {
        const routes = [...pageRouting];
        this.billingFeatureTurnedOn(routes);
        this.hasAccessForCommision(routes);
        this.claimFeatureTurnedOn(routes);
        documentFeatureTurnedOn(routes);
        return routes;
    }

    billingFeatureTurnedOn = (routes) => {
        if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' })) {
            const billingRoute = {
                path: '/billing',
                componentPath: 'Policies/Billing/Billing'
            };
            routes.push(billingRoute);
        }
    };

    hasAccessForCommision = (routes) => {
        const { commissionTurnedOn } = this.state;
        if (
            commissionTurnedOn
            && isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'commission' })
        ) {
            const commissionRoute = {
                path: '/commission',
                component: PolicyCommission
            };
            routes.push(commissionRoute);
        }
    };

    claimFeatureTurnedOn = (routes) => {
        if (this.isClaimsTurnedOn()) {
            const claimRoute = {
                path: '/claims',
                component: PolicyClaims
            };
            routes.push(claimRoute);
        }
    };

    updateCountInfo = (type) => {
        const { policyResponse } = this.state;
        const currentCount = _.get(policyResponse, `numberOf${type}`);
        _.set(policyResponse, `numberOf${type}`, currentCount + 1);
        this.setState({ policyResponse });
    };

    updateDocumentCount = (count, type = 'Documents') => {
        const { policyResponse } = this.state;
        _.set(policyResponse, `numberOf${type}`, count);
        this.setState({ policyResponse });
    };

    getPolicyDetails = async () => {
        const {
            authenticated,
            authHeader,
            match: {
                params: { policyNumber }
            },
            location: { state: redirectPath, pathname }
        } = this.props;

        this.setState({
            isLoading: true
        });

        if (authenticated) {
            this.getCommissionTurnedOn(authHeader);
            const getPolicyResponse = await PolicyService.getPolicy(policyNumber, authHeader);
            this.getGroupAccessPermission(authHeader, getPolicyResponse);
            const routePath = pathname && (pathname.trim().split('/') || []);
            const selectedPageFromPath = routePath[routePath.length - 1];
            const activeTile = selectedPageFromPath || redirectPath || 'summary';
            const { latestPeriod, asOfDatePeriod } = getPolicyResponse;
            let policyStatusLabel;
            const today = moment();
            const policyPeriod = _.isUndefined(asOfDatePeriod) ? latestPeriod : asOfDatePeriod;
            if (!_.isUndefined(policyPeriod) && (policyPeriod.canceled || policyPeriod.status === 'Withdrawn')) {
                policyStatusLabel = messages.cancelled;
            } else if (!_.isUndefined(policyPeriod) && policyPeriod.status === 'Renewing') {
                policyStatusLabel = messages.renewal;
            } else if (!_.isUndefined(policyPeriod) && moment(_.get(policyPeriod, 'editEffectiveDate_ML')).isAfter(today, 'd')) {
                policyStatusLabel = messages.scheduled;
            } else if (!_.isUndefined(policyPeriod) && policyPeriod.displayStatus === 'Expired') {
                policyStatusLabel = messages.expired;
            } else {
                policyStatusLabel = messages.active;
            }

            this.setState({
                showContingenciesErrorIcon: getPolicyResponse?.numberOfOpenContingencies > 0
            });

            this.setState({
                currentView: activeTile,
                policyResponse: getPolicyResponse,
                policyStatusLabel,
                accountNumber: latestPeriod?.accountNumber_ML
            });

            this.callIdentifyAPI(activeTile, getPolicyResponse);
        }
        await PolicyService.getPolicyBillingSummaryInfo(policyNumber, authHeader).then(
            (billingResponseData = {}) => {
                if (!_.isUndefined(billingResponseData.policyPeriodBillingSummaries)) {
                    const billingData = billingResponseData.policyPeriodBillingSummaries;
                    const billingIcon = _.get(billingData, '[0].isDelinquent')
                        ? 'mi-warning'
                        : 'mi-payment';
                    this.setState({
                        policyBillingData: billingResponseData,
                        billingIcon: billingIcon
                    });
                } else {
                    const billingIcon = 'mi-payment';
                    this.setState({
                        billingIcon: billingIcon
                    });
                }
            }
        );
        await PolicyService.addRecentlyViewedPolicy(policyNumber, authHeader);
        this.setState({
            isLoading: false
        });
    };

    getCommissionTurnedOn = async (authHeader) => {
        const permissionDTO = {
            permission: 'viewcommissions'
        };
        const commissionTurnedOn = await UserService.hasUserSystemPermission(
            permissionDTO,
            authHeader
        );
        this.setState({ commissionTurnedOn });
    };

    getGroupAccessPermission = async (authHeader, policy) => {
        MLStateRolloutService.checkIsGroupEnabled(policy?.latestPeriod?.baseState, authHeader).then((isGroupEligible) => {
            isGroupEligible = policy?.latestPeriod?.producerCode_ML?.producerType_ML === "ia" ? false : isGroupEligible
            this.setState({ canAccessGroup : isGroupEligible });
        });
    };

    isClaimsTurnedOn = () => {
        return isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'claim' });
    };

    handleTilesOnClick = (id) => {
        this.setState({ currentView: id });
    };

    getMetadataImplementation = () => {
        const {
            policyResponse,
            currentView,
            billingIcon,
            commissionTurnedOn,
            policyBillingData
        } = this.state;
        const baseClassName = 'ml-leftrail-nav__menu-item ';
        const carretIconClassName = 'right-chevron';
        const productName = _.get(policyResponse, 'product.productCode');
        const overrides = {
            [currentView]: {
                active: true
            },
            policyHeaderNameH2: {
                content: policyResponse.account.accountHolder.displayFullName_Ext
            },
            policyHeaderNumberH2: {
                content: policyResponse.policyNumber
            },
            summary: {
                className: cx(baseClassName, carretIconClassName, { 'active': currentView === 'summary' })
            },
            activities: {
                className: cx(baseClassName, carretIconClassName, { 'active': currentView === 'activities' })
            },
            riskAnalysis: {
                className: cx(baseClassName, carretIconClassName, { 'active': currentView === 'riskAnalysis' })
            },
            documents: {
                className: cx(baseClassName, carretIconClassName, { 'active': currentView === 'documents' })
            },
            billing: {
                active: currentView === 'billing',
                tileIcon: billingIcon,
                visible: isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' }),
                className: cx(baseClassName, carretIconClassName, { 'active': currentView === 'billing' })
            },
            claims: {
                active: currentView === 'claims',
                visible: this.isClaimsTurnedOn(),
                className: cx(baseClassName, carretIconClassName, { 'active': currentView === 'claims' })
            },
            contingencies: {
                active: currentView === 'contingencies',
                className: cx(baseClassName, carretIconClassName, { 'active': currentView === 'contingencies' }),
                showErrorIcon: this.state.showContingenciesErrorIcon
            },
            policyProductName: {
                content: this.getAccountHolderNameandNumber(policyResponse, '')
            },
            policyStatus: {
                message: this.getAccountHolderNameandNumber(policyResponse, 'status')
            },
            accountHeader: {
                redirectPath: `/accounts/${policyResponse.account.accountNumber}/summary`,
                displayName: policyResponse.account.accountHolder.displayName,
                message: messages.accountNavigation
            },
            policyIcon: {
                icon: LobIconUtil.getMaterialIcon(productName)
            }
        };

        const resolvers = {
            resolveComponentMap: {
                mltilecomponent: MLTileComponent
            },
            resolveCallbackMap: {
                handleTilesOnClick: this.handleTilesOnClick
            },
            resolveClassNameMap: styles
        };

        return (
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={policyResponse}
                overrideProps={overrides}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                className="display-flex clearfix"
            />
        )
    };


    navigateToAccount = () => {
        const { history } = this.props;
        const { accountNumber } = this.state;
        const accountPath = `/accounts/${accountNumber}/summary`;
        history.push(accountPath);
    };

    navigateToPolicy = (polNum) => {
        const { history } = this.props;
        const newPolicyPath = `/policies/${polNum}/summary`;
        history.push(newPolicyPath);
    };

    navigateToButton = (polSummaries, translator) => {
        const { accountNumber } = this.state;
        const getNavigateToContent = () => {
            return !_.isEmpty(polSummaries) && (
                <ul className={cx(styles.policyNavigationList, 'styled-ul-list')}>
                    {polSummaries.map((pol) => {
                        return (
                            <li key={pol.policyNumber} onClick={() => this.navigateToPolicy(pol.policyNumber)}>
                                {pol.policyNumber}
                            </li>
                        );
                    })}
                    <li key="accountView" onClick={() => this.navigateToAccount(accountNumber)}>
                        {translator(messages.accountView)}
                    </li>
                </ul>
            );
        };


        return (
            <Tooltip
                id="navigateToTooltip"
                placement="bottom"
                trigger="click"
                content={getNavigateToContent()}
            >
                <Button type="outlined" className={styles.pullLeft}>
                    {translator(messages.navigateTo)}
                    <i className="icon-ml-carrot-down-outline margin-left-5" />
                </Button>
            </Tooltip>
        );
    }

    showNewQuoteDialog = (account) => {
        const { history, viewModelService, authHeader } = this.props
        const translator = this.context;
        const accountVM = viewModelService.create(account, 'pc', 'edge.capabilities.gateway.account.dto.AccountDTO');
        const overrides = {
            model: accountVM,
            history
        };

        const componentProps = {
            title: translator(MLNewQuoteDialogModalMessages.startAQuote),
            overrideProps: overrides,
            CustomComponent: MLNewQuoteDialogModal,
            buttonType: 'outlined',
            showFooterOnCustomComponent: false,
            additionalPEStyle: 'customFooterModal',
            viewModelService,
            authHeader
        };
        this.props.modalContext.showModal(
            <FormModalPopover {...componentProps} />
        );
    };


    handleNewQuoteClick = () => {
        const { authHeader } = this.props;
        const {
            accountNumber
        } = this.state;

        if (_.isUndefined(accountNumber)) {
            return;
        }

        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_Add New Quote`);
        const accountDetailsPromise = AccountService.getAccountDetails(accountNumber, authHeader);
        accountDetailsPromise.then((account) => {
            this.showNewQuoteDialog(account);
        });
    };


    // Policy Change Button Functions
    isSevenDayAk = (latestPeriod, product) => {
        if (!isUndefined(latestPeriod)) {
            const { termType_ML: termType, address_ML } = latestPeriod;

            return termType === '7Days'
                && address_ML.state === 'AK'
                && product === 'PersonalAuto';
        }

        return false;
    };

    getEffDateForEarliestCancelablePeriod = (policy) => {
        if (policy.periods) {
            const periods = policy.periods;
            periods.sort((a, b) => {
                return DateUtil.compareIgnoreTime(
                    MLLocalDateUtil.localDate2Date(a.editEffectiveDate_ML),
                    MLLocalDateUtil.localDate2Date(b.editEffectiveDate_ML)
                );
            });
            const period = periods.find((p) => p.canCancel === true);
            if (period) {
                return period.editEffectiveDate_ML;
            }
        }
    };

    compareObjectsByProperty = (asOfDatePeriod, latestPeriod, canRewrite, displayStatus) => {
        if (asOfDatePeriod[canRewrite] === latestPeriod[canRewrite]) {
            return true
        }

        if (asOfDatePeriod[canRewrite] !== latestPeriod[canRewrite] && asOfDatePeriod[displayStatus] === "Canceled") {
            var recentPeriodFlag = new Date(latestPeriod.createTime_ML) > new Date(asOfDatePeriod.createTime_ML);

            if (recentPeriodFlag) {
                return latestPeriod[canRewrite]
            } else {
                return asOfDatePeriod[canRewrite]
            }
        }

        return false;
    }

    convertLocalDateToDate = (localDate) => {
        if (_.isNil(localDate)) {
            return '';
        }
        const parsedDate = new Date(localDate.year, localDate.month, localDate.day);
        return moment(parsedDate).format('MM/YYYY');
    };

    render() {
        const {
            policyResponse,
            isLoading,
            policyBillingData,
            policyStatusLabel
        } = this.state;
        if (isLoading) {
            // return <Loader loaded={!isLoading} />;
            return <></>
        }

        if (_.isEmpty(policyResponse)) {
            return null;
        }
        const {
            match: { url },
            intl,
            history
        } = this.props;

        const translator = this.context;
        const policyDetailsData = {
            policyResponse: policyResponse,
            getUpdateCountInfo: this.updateCountInfo,
        };
        const latestPeriod = policyResponse.latestPeriod;
        const asOfDatePeriod = policyResponse.asOfDatePeriod;
        const productCode = _.get(policyResponse, 'product.publicID');
        const isSevenDay = this.isSevenDayAk(latestPeriod, productCode);
        const earliestCancellationDate = this.getEffDateForEarliestCancelablePeriod(policyResponse);
        const polSummaries = _.get(policyResponse, 'account.policySummaries', []);
        const coveragePartType = _.get(policyResponse, 'latestPeriod.lobs_ML.homeowners.coveragePartType_ML');
        const canCreateSub = _.get(policyResponse, 'account.canUserCreateSubmission');

        const isAsOfPeriod_LatestPeriodSame = this.compareObjectsByProperty(asOfDatePeriod, latestPeriod, 'canRewrite_ML', 'displayStatus')
        const policyPeriod = (_.isUndefined(asOfDatePeriod) || !isAsOfPeriod_LatestPeriodSame) ? latestPeriod : asOfDatePeriod;
        const today = moment();
        const policyCanceledDateWithAdditionalDays = moment(_.get(policyResponse, 'latestPeriod.expirationDate')).add(91, 'd');
        const hideMakeChangesButton = (policyPeriod.canceled && policyCanceledDateWithAdditionalDays.isBefore(today, 'd'));

        const canExcludeDrivers = () => {
            return latestPeriod.canExcludeDrivers_ML;
        };
        const IsEffectiveDate = (editEffectiveDate, effectiveDate) => {
            return JSON.stringify(editEffectiveDate) === JSON.stringify(effectiveDate);
        };
        const filterByPolicyNumber = policyResponse?.account?.policySummaries?.filter((item) => item?.policyNumber === policyResponse?.policyNumber)?.map((cancelDate) => cancelDate)
        let cancellationStatus = '';
        if (filterByPolicyNumber.length > 0) {
            const [{ cancelledDate_ML }] = filterByPolicyNumber
            const parseCancelDate = new Date(cancelledDate_ML?.year, cancelledDate_ML?.month, cancelledDate_ML?.day)
            const cancellationDate = (inputDate) => {
                const currentDate = new Date();
                currentDate.setHours(0, 0, 0, 0);
                inputDate.setHours(0, 0, 0, 0);
                if (!IsEffectiveDate(cancelledDate_ML, latestPeriod?.effectiveDate)) {
                    if (inputDate < currentDate) {
                        return true;
                    } else if (inputDate.getTime() === currentDate.getTime()) {
                        return true;
                    } else if (inputDate > currentDate) {
                        return false;
                    }
                } else {
                    return true
                }
            };
            if (cancelledDate_ML?.year !== undefined && cancelledDate_ML?.month !== undefined && cancelledDate_ML?.day !== undefined) {
                cancellationStatus = cancellationDate(parseCancelDate);
            }
        }

        askSoService.storeCurrentPageData(this.state.policyResponse.account.accountHolder.primaryAddress.state, this.state.currentPolicy, this.state.policyResponse.product.productCode, '');

        return (
            <DependencyProvider value={{ DocumentPageService }}>
                <div className="display-flex clearfix">
                    {this.getMetadataImplementation()}
                    <div className={cx('ml-leftrail-nav__wrapper-right')}>
                        <div className={cx('ml-main-header short for-details')}>
                            <div className="row">
                                <div className="col-md-6">
                                    {this.navigateToButton(polSummaries, translator)}
                                    <div className={cx(styles.customerSince, 'col-md-6')}>
                                        <strong>{translator(messages.customerSince)}</strong>
                                        {this.convertLocalDateToDate(policyResponse.latestPeriod.effectiveDate)}&nbsp;
                                        <span className="ml-pill ml-pill-default">{translator(policyStatusLabel)}</span>
                                    </div>
                                </div>
                                <div className="col-md-6 buttons-right">
                                    <Button className={styles.pullRight} type="outlined" onClick={this.handleNewQuoteClick} visible={this.showNewQuoteButton && canCreateSub}>
                                        {translator(messages.addNewQuote)}
                                    </Button>
                                    {productCode && !isSevenDay && (
                                        <div className={styles.polChangeBtn}>
                                            <MLPolicyChangeBtnComponent
                                                policyNumber={policyResponse.policyNumber}
                                                productCode={productCode}
                                                canChange={!policyPeriod.canceled}
                                                canCancel={policyPeriod.canCancel && !policyPeriod.canceled}
                                                canAccessGroup={this.state.canAccessGroup}
                                                isFutureCancellation={cancellationStatus}
                                                earliestCancellationDate={earliestCancellationDate}
                                                policyTermEffectiveDate={policyPeriod.effectiveDate}
                                                policyTermExpirationDate={policyPeriod.expirationDate}
                                                canRewrite={policyPeriod.canRewrite_ML}
                                                canReinstate={policyPeriod.canceled && policyPeriod.canReinstate_ML}
                                                allPolicies={polSummaries}
                                                canManageBundle
                                                canExcludeDrivers={canExcludeDrivers}
                                                coveragePartType={coveragePartType}
                                                history={history}
                                                hideMakeChangesButton={hideMakeChangesButton}
                                                isModernProduct={policyPeriod.isModernProduct_Ext}
                                                policyInformation={policyResponse}
                                                baseState={policyPeriod.baseState}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className='pc-page-content'>
                            <CommonRoutes
                                steps={this.getRoutesWithFeature()}
                                basePath={url}
                                setDocumentCount={this.updateDocumentCount}
                                policyNumber={policyResponse.policyNumber}
                                policyDetailsData={policyDetailsData}
                                billingData={policyBillingData}
                            />
                        </div>
                    </div>
                </div>
            </DependencyProvider>
        );
    };
}
const MLPolicyDetails = withModalContext(MLPolicyDetailsWithNotificationWithoutModalContext);
export default withMLModalService(withRouter(withIntl(withAuthenticationContext(withViewModelService(MLPolicyDetails)))));
